<div class="flex flex-col">
    @if (loading) {
        <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'"></mat-progress-bar>
    }
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'holidayCalendar.new' | transloco }}</div>
        <div class="flex items-center">
            @if (!loading && !readonly) {
                <button mat-stroked-button class="block 5xl:hidden text-on-primary mr-4" (click)="accept()">
                    {{ 'accept' | transloco }}
                </button>
            }
            <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>

    <form [formGroup]="formGroup" class="flex flex-col p-6 w-full">

        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-full">
            <mat-label>{{ 'name' | transloco }}</mat-label>
            <input matInput type="text" formControlName="name">
            @if (formGroup.get('name').hasError('required')) {
                <mat-error>
                    {{ 'errorRequiredField' | transloco }}
                </mat-error>
            }
            @if (formGroup.get('name').hasError('maxlength')) {
                <mat-error>
                    {{ 'errorMaxLengthField' | transloco:{ requiredLength: formGroup.get('name').errors.maxlength.requiredLength } }}
                </mat-error>
            }
            @if (formGroup.get('name').hasError('pattern')) {
                <mat-error>
                    {{ 'holidayCalendar.patternError' | transloco }}
                </mat-error>
            }
        </mat-form-field>

        <div class="flex w-full items-baseline gap-4">
            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-1/2">
                <mat-label>{{ 'holidayCalendar.copyFromAnother' | transloco }}</mat-label>
                <mat-select formControlName="syncOid" class="w-full">
                    <mat-option>
                        {{ 'emptyOption' | transloco }}
                    </mat-option>
                    @for (key of calendarGroups.keys(); track key) {
                        <mat-optgroup [label]="key">
                            @for (cal of calendarGroups.get(key); track cal._oid) {
                                <mat-option [value]="cal._oid">
                                    {{ cal.name }}
                                </mat-option>
                            }
                        </mat-optgroup>
                    }
                </mat-select>
            </mat-form-field>
            @if (formGroup.get('syncOid').value) {
                <mat-slide-toggle formControlName="keepSync">{{ 'holidayCalendar.keepSync' | transloco }}</mat-slide-toggle>
            }
        </div>

        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-1/2">
            <mat-label>{{ 'holidayCalendar.weekDays' | transloco }}</mat-label>
            <mat-select formControlName="weekDays" class="w-full" multiple>
                @for (option of weekdaysOption; track option.code) {
                    <mat-option [value]="option.code">
                        {{ option.value | localize }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <div class="flex justify-center items-center gap-2 w-full mb-4">
            <button mat-icon-button (click)="previousYear()">
                <mat-icon [svgIcon]="'mat_outline:chevron_left'"></mat-icon>
            </button>
            {{ year }}
            <button mat-icon-button (click)="nextYear()" [disabled]="disableNextYear">
                <mat-icon [svgIcon]="'mat_outline:chevron_right'"></mat-icon>
            </button>
        </div>
        <div class="flex flex-col w-full gap-4">
            @for (row of months(); track row) {
                <div class="flex w-full justify-center gap-4">
                    @for (month of row; track month) {
                        <mat-card class="bg-gray-50 dark:bg-slate-900 p-2 w-80 max-w-1/4">
                            <mat-calendar #calendar [startAt]="getStartDate(month)" [maxDate]="getMaxDate(month)" [minDate]="getMinDate(month)"
                                (selectedChange)="select($event,calendar)" [dateClass]="isSelected" [dateFilter]="dateFilter"></mat-calendar>
                        </mat-card>
                    }
                </div>
            }
        </div>

        @if (!loading && !readonly) {
            <div class="hidden 5xl:flex justify-end p-4 sticky bottom-0">
                <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
                    {{ 'cancel' | transloco }}
                </button>
                <button class="mr-2" mat-raised-button color="primary" (click)="accept()" [disabled]="formGroup.invalid">
                    {{ 'accept' | transloco }}
                </button>
            </div>
        }
    </form>
</div>
    